import { getDieselConsumptionDetails } from '../services/DieselConsumptionServices';
import { openHtmlInApp } from './openPdfInApp';

const PURPOSE_LABELS = {
    mixer: 'Mixer',
    pump: 'Pump',
    dg_set: 'DG Set',
    tipper: 'Tipper',
    loader: 'Loader',
    generator: 'Generator',
    other: 'Other',
};

function purposeLabel(value) {
    return PURPOSE_LABELS[value] || value || '-';
}

function calcKmHmReading(line) {
    const opening = Number(line.opening_meter) || 0;
    const closing = Number(line.closing_meter) || 0;
    const meterRun = closing - opening;
    if (meterRun <= 0) return '-';
    return meterRun.toFixed(3);
}

function calcAvgKmHmPerLtr(line) {
    const dieselQty = Number(line.consumed_qty) || 0;
    const meterRun = Number(calcKmHmReading(line));
    if (dieselQty <= 0 || !(meterRun > 0)) return '-';
    return (meterRun / dieselQty).toFixed(3);
}

export async function printDieselConsumption(cookies, id) {
    const record = await getDieselConsumptionDetails(cookies, id);

    const lines = (record.detail_list || []).map((line, index) => `
        <tr>
            <td style="text-align:center">${index + 1}</td>
            <td>${line.equipment_name || '-'}</td>
            <td>${line.driver_name || '-'}</td>
            <td>${purposeLabel(line.purpose)}</td>
            <td>${line.product_name || '-'}</td>
            <td style="text-align:right">${Number(line.opening_meter || 0).toFixed(3)}</td>
            <td style="text-align:right">${Number(line.closing_meter || 0).toFixed(3)}</td>
            <td style="text-align:right">${Number(line.consumed_qty || 0).toFixed(3)}</td>
            <td>${line.unit || 'Ltr'}</td>
            <td style="text-align:right">${calcKmHmReading(line)}</td>
            <td style="text-align:right">${calcAvgKmHmPerLtr(line)}</td>
        </tr>
    `).join('');

    const status = record.status === true || record.status === 1 || record.status === 'Active'
        ? 'Active'
        : 'Cancelled';

    openHtmlInApp(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Diesel Consumption ${record.consumption_no || record.sl_no || ''}</title>
            <style>
                body { font-family: Arial, sans-serif; margin: 24px; color: #222; }
                h2 { margin-bottom: 4px; }
                .meta { margin-bottom: 16px; }
                .meta div { margin: 4px 0; }
                table { width: 100%; border-collapse: collapse; margin-top: 12px; }
                th, td { border: 1px solid #ccc; padding: 6px 8px; font-size: 13px; }
                th { background: #e8f4fc; }
            </style>
        </head>
        <body>
            <h2>Diesel Consumption Note</h2>
            <div class="meta">
                <div><strong>Plant:</strong> ${record.plant_alias || '-'}</div>
                <div><strong>Consumption No:</strong> ${record.consumption_no || `${record.prefix || ''}/${record.sl_no || ''}`}</div>
                <div><strong>Date:</strong> ${record.consumption_date || '-'} &nbsp; <strong>Time:</strong> ${(record.consumption_time || '').slice(0, 5)}</div>
                <div><strong>Issued By:</strong> ${record.issued_by || '-'} &nbsp; <strong>Status:</strong> ${status}</div>
                <div><strong>Total Diesel Qty:</strong> ${Number(record.total_diesel_qty || 0).toFixed(3)}</div>
                <div><strong>Remarks:</strong> ${record.remarks || '-'}</div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Equipment</th>
                        <th>Driver</th>
                        <th>Purpose</th>
                        <th>Product</th>
                        <th>Opening</th>
                        <th>Closing</th>
                        <th>Consumed</th>
                        <th>Unit</th>
                        <th>K(HM) Reading</th>
                        <th>Avg K(H)M/ Ltr.</th>
                    </tr>
                </thead>
                <tbody>${lines}</tbody>
            </table>
        </body>
        </html>
    `, { title: 'Diesel Consumption' });
}
